export * from './recover-password.component';



// WEBPACK FOOTER //
// ./src/app/login/recover-password/index.ts